import React from "react";
import { Box, Typography, FormControlLabel, Checkbox, Grid } from "@mui/material";
import { Communication } from "../../models/electronicsConfiguration.ts";

interface Props {
  data: Communication;
  onChange: (updated: Communication) => void;
}

const CommunicationForm: React.FC<Props> = ({ data, onChange }) => {
  const update = (field: keyof Communication, value: any) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Kommunikationsschnittstellen</Typography>
      <Box mt={2} />
        <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={data.rs232.enable}
                        onChange={(e) => update("rs232", { ...data.rs232, enable: e.target.checked })}
                    />
                    }
                    label="RS232"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={data.rs485.enable}
                        onChange={(e) => update("rs485", { ...data.rs485, enable: e.target.checked })}
                    />
                    }
                    label="RS485"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={data.uart.enable}
                        onChange={(e) => update("uart", { ...data.uart, enable: e.target.checked })}
                    />
                    }
                    label="UART"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={data.i2c0.enable}
                        onChange={(e) => update("i2c0", { ...data.i2c0, enable: e.target.checked })}
                    />
                    }
                    label="I2C 0"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={data.i2c1.enable}
                        onChange={(e) => update("i2c1", { ...data.i2c1, enable: e.target.checked })}
                    />
                    }
                    label="I2C 1"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={data.usb.enable}
                        onChange={(e) => update("usb", { ...data.usb, enable: e.target.checked })}
                    />
                    }
                    label="USB2.0"
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
                <FormControlLabel
                    control={
                    <Checkbox
                        checked={data.sd_card.enable}
                        onChange={(e) => update("sd_card", { ...data.sd_card, enable: e.target.checked })}
                    />
                    }
                    label="SD-Karte"
                />
            </Grid>
        </Grid>
    </Box>
  );
};

export default CommunicationForm;
